import React, { ReactNode } from 'react';
import {
  faDownload,
  faFileArchive,
  faTrash,
  faUser,
  faSync,
  faBan,
  faUnlock,
  // faPaperPlane,
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Dispatch } from 'redux';
import { EventPreviewEmailStatus, EventState, EventType, ZipFileState } from 'stageclip-common';

import {
  createAssignEventRequestAction,
  createDeleteParticipantsDataAction,
  createDeleteParticipantsVgZipAction,
  createDeleteParticipantsVgVideoAction,
  createDeleteParticipantsZipAction,
  createEventRequestedAction,
  createGenerateParticipantsVgZipAction,
  createGenerateParticipantsZipAction,
} from '../../actions/eventActions';
import * as DateHelpers from '../../helpers/dateHelpers';
import * as NotificationHelper from '../../helpers/notificationHelper';
import * as PermissionsHelper from '../../helpers/permissionsHelper';
import * as UploadParticipantsHelper from '../../helpers/uploadParticipantHelper';
import { NormalizedClient } from '../../models/normalized/normalizedClient';
import { NormalizedEvent } from '../../models/normalized/normalizedEvent';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { getItem } from '../../store/selectors';
import Button from '../buttons/button';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';
import { PageTitle } from '../pages/pageTitle';

import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { callApi } from 'helpers/callApi/callApi';
import { synchronizeMOEventParticipants } from 'api/mo/mo.actions';
import ActionsLogTable from './actionsLogTable';
import AddEventTransitionButton from './addEventTransitionButton';
import AddEventVideoForm from './addEventVideoForm';
import EditEventForm from './editEventForm';
import EventDetails from './eventDetails';
import styles from './eventPage.module.scss';
import AddParticipantForm from './participants/addParticipantForm';
import AegisubNamesModal from './participants/aegisubNamesModal';
import AegisubProcessedDataModal from './participants/aegisubProcessedDataModal';
import EditParticipantForm from './participants/editParticipantForm';
import ParticipantsTable from './participants/participantsTable';
import UnKnownParticipantsTable from './participants/unKnownParticipantsTable';
import SendParticipantsToGeneratorForm from './participants/sendParticipantsToGeneratorForm';
import UploadAegisubResultForm from './participants/uploadAegisubResultForm';
import UploadParticipantsForm from './participants/uploadParticipantsForm';
import SendToNlpForm from './sendToNlpModal/sendToNlpModalForm';
import GenerateVgVideoCeremonyForm from './virtual-graduation/generateVgVideoCeremonyForm';
import EventVideosTable from './videos/eventVideosTable';
import { MoParticipantsSyncModal } from './moParticipantsSyncModal/MoParticipantsSyncModal';
import { SendReminderButtonContainer } from './videos/sendReminderButton/SendReminderButtonContainer';
import { CancelEventModal } from './cancelEventModal/CancelEventModal';
import { EmailsLogTableContainer } from './emailsLogTable/EmailsLogTableContainer';
import SendParticipantsToRemotionGeneratorForm from './participants/SendParticipantsToRemotionGeneratorForm';
import { NlpTranscriptTableContainer } from './nlpTranscriptTable/NlpTranscriptTableContainer';
import { UnlockTemplatetModal } from './unlockTemplateModal/UnlockTemplateModal';

interface EventPageStateProps extends BaseStateProps {
  event: NormalizedEvent;
  client: NormalizedClient;
  eventLoaded: boolean;
}

interface EventPageDispatchProps extends BaseDispatchProps {
  loadEvent: (c: EventPage) => void;
  assignEvent: (c: EventPage, eventId: string, userId: string) => void;
  generateParticipantsZip: (c: EventPage, eventId: string) => void;
  generateParticipantsVgZip: (c: EventPage, eventId: string) => void;
  deleteParticipantsZip: (c: EventPage, eventId: string) => void;
  deleteParticipantsVgZip: (c: EventPage, eventId: string) => void;
  deleteParticipantsVgVideo: (c: EventPage, eventId: string) => void;
  deleteParticipantsData: (c: EventPage, eventId: string) => void;
  syncMOParticipants: (eventId: string) => any;
  openCancelEventModal: (event: NormalizedEvent) => void;
  openUnlockTemplateModal: (event: NormalizedEvent) => void;
}

class EventPage extends ComponentBase<RouteComponentProps<any>, EventPageStateProps, EventPageDispatchProps> {
  constructor(props: any) {
    super(props);
    this.assignEventToCurrentUser = this.assignEventToCurrentUser.bind(this);
    this.loadEvent = this.loadEvent.bind(this);
    this.generateParticipantsZip = this.generateParticipantsZip.bind(this);
    this.generateParticipantsVgZip = this.generateParticipantsVgZip.bind(this);
    this.deleteParticipantsZip = this.deleteParticipantsZip.bind(this);
    this.deleteParticipantsVgZip = this.deleteParticipantsVgZip.bind(this);
    this.downloadParticipantsZip = this.downloadParticipantsZip.bind(this);
    this.downloadParticipantsVgZip = this.downloadParticipantsVgZip.bind(this);
    this.downloadVgVideoCeremony = this.downloadVgVideoCeremony.bind(this);
    this.deleteParticipantsVgVideo = this.deleteParticipantsVgVideo.bind(this);
    this.deleteParticipantsData = this.deleteParticipantsData.bind(this);
  }

  handleSyncMOParticipants = (eventId: string) => {
    const { syncMOParticipants } = this.props;

    callApi({
      action: () => syncMOParticipants(eventId),
    });
  };

  protected dataLoaded(props: any) {
    return !!props.event && !!props.eventLoaded;
  }

  protected async loadData(props: any) {
    await props.loadEvent(this);
  }

  protected loggedInRender() {
    const { event, openCancelEventModal, openUnlockTemplateModal } = this.props;
    const { marchingOrderId, id, state } = event;
    const { handleSyncMOParticipants } = this;

    return (
      <>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.EditParticipant) && (
          <EditParticipantForm
            eventId={event.id}
            eventType={event.type}
            isSurveyTurnedOn={event.survey}
            isSnapchatTurnedOn={event.snapchat}
            snapcodes={event.snapcodes}
            clipPurchaseType={event.clipPurchaseType}
            event={event}
          />
        )}
        <PageTitle displayTitle={this.props.client.name} pageTitle={this.getPageTitle()} subtitles={this.subtitles()} />
        <EventDetails event={this.props.event} />
        {!this.props.event.archived && (
          <div className={styles.actions}>
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AddEventVideo) && (
              <AddEventVideoForm eventId={this.props.event.id} />
            )}
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.EditEvent) && (
              <EditEventForm event={this.props.event} />
            )}
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.AssignEvent) &&
              event.state !== EventState.Complete && (
                <Button onClick={this.assignEventToCurrentUser} text="Assign to me" allCapitals icon={faUser} />
              )}
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.ApplyTransition) && (
              <AddEventTransitionButton event={event} />
            )}
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CancelEvent) &&
              state !== EventState.Cancelled && (
                <Button onClick={() => openCancelEventModal(event)} text="Cancel event" allCapitals icon={faBan} />
              )}
            {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.EditEvent) &&
              event.type === EventType.LiveEvent &&
              event.eventConfiguration?.isLiveTemplateFinalize && (
                <Button
                  onClick={() => openUnlockTemplateModal(event)}
                  text="Unlock template"
                  allCapitals
                  icon={faUnlock}
                />
              )}
          </div>
        )}
        <Tabs className={styles.tabs}>
          <TabList>
            <Tab>Participants</Tab>
            <Tab>Videos</Tab>
            <Tab>Actions Log</Tab>
            <Tab>Blacklist</Tab>
            <Tab>Emails Log</Tab>
            {(this.props.event.type === EventType.LiveEvent ||
              this.props.event.type === EventType.HybridClipsOnlyEvent ||
              this.props.event.type === EventType.HybridFullCeremonyEvent) && <Tab>Unknown Review</Tab>}
            {this.props.event.type === EventType.LiveEvent && this.props.event.isSelfClipping && (
              <Tab>NLP Transcript</Tab>
            )}
          </TabList>
          <TabPanel className={styles.tabPanel}>
            {!this.props.event.archived && (
              <div className={styles.actions}>
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UploadParticipant) &&
                  UploadParticipantsHelper.eventStateAllowForParticipantUploads(this.props.event.state) && (
                    <UploadParticipantsForm eventId={this.props.event.id} onSuccessCallback={this.loadEvent} />
                  )}
                <AegisubNamesModal eventId={this.props.event.id} />
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UploadAegisubResult) && (
                  <UploadAegisubResultForm eventId={this.props.event.id} />
                )}
                {(this.props.event.state === EventState.ReviewNeeded ||
                  this.props.event.state === EventState.Complete) && (
                  <AegisubProcessedDataModal eventId={this.props.event.id} />
                )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UploadParticipant) && (
                  <AddParticipantForm
                    eventId={this.props.event.id}
                    isSurveyTurnedOn={this.props.event.survey}
                    isSnapchatTurnedOn={this.props.event.snapchat}
                    snapcodes={this.props.event.snapcodes}
                  />
                )}
                {!!marchingOrderId && (
                  <Button
                    text="sync mo"
                    inverseColours
                    allCapitals
                    icon={faSync}
                    onClick={() => handleSyncMOParticipants(id)}
                  />
                )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.SendParticipantsToGenerator) &&
                  this.props.event.type !== EventType.LiveEvent &&
                  (this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) && (
                    <SendParticipantsToGeneratorForm eventId={this.props.event.id} />
                  )}

                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GenerateParticipantsZip) &&
                  (this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) &&
                  !this.props.event.zipFile && (
                    <Button
                      text={
                        this.props.event.zipFileState === ZipFileState.GeneratingParticipantsZip
                          ? 'Please wait for the zip to be generated'
                          : 'Generate participants zip'
                      }
                      onClick={this.generateParticipantsZip}
                      disabled={this.props.event.zipFileState === ZipFileState.GeneratingParticipantsZip}
                      inverseColours
                      allCapitals
                      icon={faFileArchive}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.SendParticipantsToRRE) &&
                  this.props.event.type === EventType.LiveEvent &&
                  (this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) && (
                    <SendParticipantsToRemotionGeneratorForm eventId={this.props.event.id} event={this.props.event} />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DownloadParticipantsZip) &&
                  (this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) &&
                  this.props.event.zipFile && (
                    <Button
                      text="Download Zip"
                      inverseColours
                      allCapitals
                      icon={faDownload}
                      onClick={this.downloadParticipantsZip}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteParticipantsZip) &&
                  (this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) &&
                  this.props.event.zipFile && (
                    <Button
                      text={
                        this.props.event.zipFileState === ZipFileState.DeletingParticipantsZip
                          ? 'Please wait for the zip to be deleted'
                          : 'Delete participants zip'
                      }
                      disabled={this.props.event.zipFileState === ZipFileState.DeletingParticipantsZip}
                      onClick={this.deleteParticipantsZip}
                      inverseColours
                      allCapitals
                      icon={faTrash}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GenerateParticipantsVgZip) &&
                  this.props.event.type === EventType.VirtualGraduation &&
                  !this.props.event.vgZipFile && (
                    <Button
                      text={
                        this.props.event.vgZipFileState === ZipFileState.GeneratingParticipantsZip
                          ? 'Please wait for the zip to be generated'
                          : 'Generate VG participants zip'
                      }
                      onClick={this.generateParticipantsVgZip}
                      disabled={this.props.event.vgZipFileState === ZipFileState.GeneratingParticipantsZip}
                      inverseColours
                      allCapitals
                      icon={faFileArchive}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DownloadParticipantsVgZip) &&
                  this.props.event.type === EventType.VirtualGraduation &&
                  this.props.event.vgZipFile && (
                    <Button
                      text="Download VG Zip"
                      inverseColours
                      allCapitals
                      icon={faDownload}
                      onClick={this.downloadParticipantsVgZip}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteParticipantsVgZip) &&
                  this.props.event.type === EventType.VirtualGraduation &&
                  this.props.event.vgZipFile && (
                    <Button
                      text={
                        this.props.event.vgZipFileState === ZipFileState.DeletingParticipantsZip
                          ? 'Please wait for the zip to be deleted'
                          : 'Delete VG participants zip'
                      }
                      disabled={this.props.event.vgZipFileState === ZipFileState.DeletingParticipantsZip}
                      onClick={this.deleteParticipantsVgZip}
                      inverseColours
                      allCapitals
                      icon={faTrash}
                    />
                  )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GenerateVgVideoCeremony) &&
                  this.props.event.type === EventType.VirtualGraduation &&
                  this.props.event.totalNoOfParticipants > 0 &&
                  !this.props.event.vgFinalCeremonyUrl && (
                    <GenerateVgVideoCeremonyForm
                      eventId={this.props.event.id}
                      vgProcessingJob={this.props.event.vgProcessingJob}
                    />
                  )}
                {this.props.event.type === EventType.VirtualGraduation && this.props.event.vgFinalCeremonyUrl && (
                  <>
                    <Button
                      text="Download VG Video Ceremony"
                      inverseColours
                      allCapitals
                      icon={faDownload}
                      onClick={this.downloadVgVideoCeremony}
                    />
                    <Button
                      text="Delete VG Video Ceremony"
                      inverseColours
                      allCapitals
                      icon={faTrash}
                      onClick={this.deleteParticipantsVgVideo}
                    />
                  </>
                )}
                {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteParticipantsData) &&
                  this.props.event.state === EventState.Complete && (
                    <Button
                      text={
                        this.props.event.deletingParticipantsData
                          ? 'Please wait for the data to be deleted'
                          : 'Delete participants data'
                      }
                      onClick={this.deleteParticipantsData}
                      inverseColours
                      disabled={this.props.event.deletingParticipantsData}
                      allCapitals
                      icon={faTrash}
                    />
                  )}
                {this.props.event.state === EventState.ReadyToClip && <SendToNlpForm eventId={this.props.event.id} />}
              </div>
            )}

            <ParticipantsTable
              eventId={this.props.event.id}
              eventType={this.props.event.type}
              archived={this.props.event.archived}
            />
          </TabPanel>
          <TabPanel className={styles.tabPanel}>
            {!this.props.event.archived &&
              PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.SendVideoReminder) &&
              !!event.vgFinalCeremonyUrl && (
                <div className={styles.actions}>
                  <SendReminderButtonContainer
                    eventId={event.id}
                    clipPreviewEmailStatus={event.clipPreviewEmail as EventPreviewEmailStatus}
                  />
                </div>
              )}
            <EventVideosTable eventId={this.props.event.id} archived={this.props.event.archived} />
          </TabPanel>
          <TabPanel className={styles.tabPanel}>
            <ActionsLogTable eventId={this.props.event.id} archived={this.props.event.archived} />
          </TabPanel>

          <TabPanel className={styles.tabPanel}>
            <ParticipantsTable
              eventId={this.props.event.id}
              eventType={this.props.event.type}
              filters={[
                {
                  id: 'blacklist',
                  value: true,
                },
              ]}
              archived={this.props.event.archived}
            />
          </TabPanel>
          <TabPanel className={styles.tabPanel}>
            <EmailsLogTableContainer eventId={this.props.event.id} />
          </TabPanel>
          {(this.props.event.type === EventType.LiveEvent ||
            this.props.event.type === EventType.HybridClipsOnlyEvent ||
            this.props.event.type === EventType.HybridFullCeremonyEvent) && (
            <TabPanel className={styles.tabPanel}>
              {!this.props.event.archived && (
                <div className={styles.actions}>
                  {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UploadParticipant) &&
                    UploadParticipantsHelper.eventStateAllowForParticipantUploads(this.props.event.state) && (
                      <UploadParticipantsForm eventId={this.props.event.id} onSuccessCallback={this.loadEvent} />
                    )}
                  <AegisubNamesModal eventId={this.props.event.id} />
                  {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.UploadAegisubResult) && (
                    <UploadAegisubResultForm eventId={this.props.event.id} />
                  )}
                  {(this.props.event.state === EventState.ReviewNeeded ||
                    this.props.event.state === EventState.Complete) && (
                    <AegisubProcessedDataModal eventId={this.props.event.id} />
                  )}
                  {!!marchingOrderId && (
                    <Button
                      text="sync mo"
                      inverseColours
                      allCapitals
                      icon={faSync}
                      onClick={() => handleSyncMOParticipants(id)}
                    />
                  )}
                  {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteParticipantsZip) &&
                    (this.props.event.state === EventState.ReviewNeeded ||
                      this.props.event.state === EventState.Complete) &&
                    this.props.event.zipFile && (
                      <Button
                        text={
                          this.props.event.zipFileState === ZipFileState.DeletingParticipantsZip
                            ? 'Please wait for the zip to be deleted'
                            : 'Delete participants zip'
                        }
                        disabled={this.props.event.zipFileState === ZipFileState.DeletingParticipantsZip}
                        onClick={this.deleteParticipantsZip}
                        inverseColours
                        allCapitals
                        icon={faTrash}
                      />
                    )}
                </div>
              )}

              <UnKnownParticipantsTable
                eventId={this.props.event.id}
                eventType={this.props.event.type}
                archived={this.props.event.archived}
              />
            </TabPanel>
          )}
          {this.props.event.type === EventType.LiveEvent && this.props.event.isSelfClipping && (
            <TabPanel className={styles.tabPanel}>
              <NlpTranscriptTableContainer eventId={this.props.event.id} />
            </TabPanel>
          )}
        </Tabs>
        <MoParticipantsSyncModal />
        <CancelEventModal />
        <UnlockTemplatetModal />
      </>
    );
  }

  private subtitles() {
    const subtitles: ReactNode[] = [];
    const displayClientDate = DateHelpers.isDifferentTimezone(this.props.event.startTime, this.props.client.timezone);

    if (this.props.event.name) {
      subtitles.push(this.props.event.name);
    }

    subtitles.push(
      <span>
        {displayClientDate && <span className={styles.emphasize}>User:</span>}
        {DateHelpers.readableDateFormat(this.props.event.startTime)}
      </span>,
    );

    if (displayClientDate) {
      subtitles.push(
        <span>
          <span className={styles.emphasize}>Client:</span>
          {DateHelpers.readableDateFormat(
            this.props.event.startTime,
            this.props.event.timezone || this.props.client.timezone,
          )}
        </span>,
      );
    }

    return subtitles;
  }

  private getPageTitle() {
    return `${this.props.client.name} ${this.props.event.name || ''} ${this.props.event.startTime}`;
  }

  private generateParticipantsZip() {
    this.props.generateParticipantsZip(this, this.props.event.id);
    NotificationHelper.success(
      'Your request has been sent. Please wait for the zip to be generated. This might take a few minutes.',
    );
  }

  private generateParticipantsVgZip() {
    this.props.generateParticipantsVgZip(this, this.props.event.id);
    NotificationHelper.success(
      'Your request has been sent. Please wait for the zip to be generated. This might take a few minutes.',
    );
  }

  private deleteParticipantsZip() {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to delete the zip? This action cannot be reverted.')) {
      this.props.deleteParticipantsZip(this, this.props.event.id);
    }
  }

  private deleteParticipantsVgZip() {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to delete the zip? This action cannot be reverted.')) {
      this.props.deleteParticipantsVgZip(this, this.props.event.id);
    }
  }

  private deleteParticipantsVgVideo() {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to delete the video? This action cannot be reverted.')) {
      this.props.deleteParticipantsVgVideo(this, this.props.event.id);
    }
    // eslint-disable-next-line no-alert
  }

  private deleteParticipantsData() {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to delete all participants data? This action cannot be reverted.')) {
      this.props.deleteParticipantsData(this, this.props.event.id);
      NotificationHelper.success('Your request has been sent. This might take a few minutes.');
    }
  }

  private async downloadParticipantsZip() {
    const link = document.createElement('a');
    link.href = this.props.event.zipFile;
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  }

  private async downloadParticipantsVgZip() {
    const link = document.createElement('a');
    link.href = this.props.event.vgZipFile;
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  }

  private async downloadVgVideoCeremony() {
    const link = document.createElement('a');
    link.href = this.props.event.vgFinalCeremonyUrl;
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  }

  private loadEvent() {
    this.props.loadEvent(this);
  }

  private assignEventToCurrentUser() {
    this.props.assignEvent(this, this.props.event.id, this.props.currentUser.id);
  }
}

function mapStateToProps(state: ClippingPlatformState, ownProps: RouteComponentProps<any>): EventPageStateProps {
  const event =
    getItem(state.entities.events, ownProps.match.params.eventId) ||
    getItem(state.entities.archivedEvents, ownProps.match.params.eventId);

  return {
    ...baseMapStateToProps(state),
    client: event ? event.client : undefined,
    event,
    eventLoaded: state.appStatus.oneLoaded[ownProps.match.params.eventId],
  };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: RouteComponentProps<any>): EventPageDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    assignEvent: (c: EventPage, eventId: string, userId: string) =>
      dispatch(createAssignEventRequestAction(eventId, userId, c, dispatch)),
    deleteParticipantsData: (c: EventPage, eventId: string) =>
      dispatch(createDeleteParticipantsDataAction(eventId, c, dispatch)),
    deleteParticipantsZip: (c: EventPage, eventId: string) =>
      dispatch(createDeleteParticipantsZipAction(eventId, c, dispatch)),
    generateParticipantsZip: (c: EventPage, eventId: string) =>
      dispatch(createGenerateParticipantsZipAction(eventId, c, dispatch)),
    deleteParticipantsVgZip: (c: EventPage, eventId: string) =>
      dispatch(createDeleteParticipantsVgZipAction(eventId, c, dispatch)),
    deleteParticipantsVgVideo: (c: EventPage, eventId: string) =>
      dispatch(createDeleteParticipantsVgVideoAction(eventId, c, dispatch)),
    generateParticipantsVgZip: (c: EventPage, eventId: string) =>
      dispatch(createGenerateParticipantsVgZipAction(eventId, c, dispatch)),
    loadEvent: (c: EventPage) => dispatch(createEventRequestedAction(ownProps.match.params.eventId, c, dispatch)),
    // @ts-ignore
    syncMOParticipants: eventId => dispatch(synchronizeMOEventParticipants(eventId)),
    openCancelEventModal: event => dispatch(createModalOpenAction(SimpleModalId.CancelEvent, { event })),
    openUnlockTemplateModal: event => dispatch(createModalOpenAction(SimpleModalId.UnlockTemplate, { event })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPage);
